/* eslint-disable react/display-name */

import AddBox from '@mui/icons-material/AddBox';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import Check from '@mui/icons-material/Check';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Clear from '@mui/icons-material/Clear';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import Edit from '@mui/icons-material/Edit';
import FilterList from '@mui/icons-material/FilterList';
import FirstPage from '@mui/icons-material/FirstPage';
import LastPage from '@mui/icons-material/LastPage';
import Remove from '@mui/icons-material/Remove';
import SaveAlt from '@mui/icons-material/SaveAlt';
import SearchIcon from '@mui/icons-material/Search';
import ViewColumn from '@mui/icons-material/ViewColumn';
import { Box, CircularProgress, Typography } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
export const tableIcons = {
    Add: forwardRef((props, ref) =>
        <AddBox
            {...props}
            ref={ref}
        />),
    FirstPage: forwardRef((props, ref) =>
        <FirstPage
            {...props}
            ref={ref}
        />),
    LastPage: forwardRef((props, ref) =>
        <LastPage
            {...props}
            ref={ref}
        />),
    NextPage: forwardRef((props, ref) =>
        <ChevronRight
            {...props}
            ref={ref}
        />),
    PreviousPage: forwardRef((props, ref) => (
        <ChevronLeft
            {...props}
            ref={ref}
        />
    )),
    ResetSearch: forwardRef((props, ref) =>
        <Clear
            {...props}
            ref={ref}
        />),
    Check: forwardRef((props, ref) =>
        <Check
            {...props}
            ref={ref}
        />),
    Clear: forwardRef((props, ref) =>
        <Clear
            {...props}
            ref={ref}
        />),
    Delete: forwardRef((props, ref) =>
        <DeleteOutline
            {...props}
            ref={ref}
        />),
    DetailPanel: forwardRef((props, ref) =>
        <ChevronRight
            {...props}
            ref={ref}
        />),
    Edit: forwardRef((props, ref) =>
        <Edit
            {...props}
            ref={ref}
        />),
    Export: forwardRef((props, ref) =>
        <SaveAlt
            {...props}
            ref={ref}
        />),
    Filter: forwardRef((props, ref) =>
        <FilterList
            {...props}
            ref={ref}
        />),
    SortArrow: forwardRef((props, ref) =>
        <ArrowDownward
            {...props}
            ref={ref}
        />),
    ViewColumn: forwardRef((props, ref) =>
        <ViewColumn
            {...props}
            ref={ref}
        />),
    Search: forwardRef((props, ref) =>
        <SearchIcon
            {...props}
            ref={ref}
        />),
    ThirdStateCheck: forwardRef((props, ref) =>
        <Remove
            {...props}
            ref={ref}
        />),

};
import React, { forwardRef } from 'react';

//? Proposition commercial component
// export const tableIcons = {
//     Add: forwardRef((props, ref) =>
//         <AddBox
//             {...props}
//             ref={ref}
//         />),
//     Check: forwardRef((props, ref) =>
//         <Check
//             {...props}
//             ref={ref}
//         />),
//     Clear: forwardRef((props, ref) =>
//         <Clear
//             {...props}
//             ref={ref}
//         />),
//     Delete: forwardRef((props, ref) =>
//         <DeleteOutline
//             {...props}
//             ref={ref}
//         />),
//     DetailPanel: forwardRef((props, ref) =>
//         <ChevronRight
//             {...props}
//             ref={ref}
//         />),
//     Edit: forwardRef((props, ref) =>
//         <Edit
//             {...props}
//             ref={ref}
//         />),
//     Export: forwardRef((props, ref) =>
//         <SaveAlt
//             {...props}
//             ref={ref}
//         />),
//     Filter: forwardRef((props, ref) =>
//         <FilterList
//             {...props}
//             ref={ref}
//         />),
//     SortArrow: forwardRef((props, ref) =>
//         <ArrowDownward
//             {...props}
//             ref={ref}
//         />),
//     ViewColumn: forwardRef((props, ref) =>
//         <ViewColumn
//             {...props}
//             ref={ref}
//         />)
// };

export const tableStyleCollab = {
    width: '850px',
    border: '1px solid #E7EAF9',
    borderRadius: '60px',
    //marginTop: '140px',
};

export const tableStyleSideBarClosed = {
    width: '1125px',
};

export const tableStyleSideBarOpen = {
    width: '1301px',
};

export const stylebuttonsubmit = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '12px 24px 12px 20px',
    gap: '8px',
    color:'white',
    //width: '109px',
    height: '56px',
    backgroundColor: '#214DCE',
    borderRadius: '8px',
};

export const defaultMaterialTheme = createTheme({
    components: {
        MuiPaper:{
            styleOverrides: {
                root: {
                    borderRadius: '20px',
                }
            }

        },
        MTableToolbar:{
            styleOverrides: {
                //'.MTableToolbar-searchField-10':{
                marginLeft:'-30px',
                //},
                '.MTableToolbar-searchField-10':{
                    marginLeft:'-30px',
                },

            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    textAlign:'center',
                    '.MuiTablePagination-selectLabel': {
                        visibility: 'hidden',
                    },
                    '.MuiTablePagination-displayedRows':{
                        visibility: 'hidden',
                    },
                    '.css-16c50h-MuiInputBase-root-MuiTablePagination-select':{
                        marginLeft:'-95px',
                    },

                    '.MTablePaginationInner-root-14':{
                        marginLeft:'-65px',
                    },

                    '.MTableToolbar-searchField-10':{
                        marginLeft:'-50px',
                    }
                },
            },
        },
    },

});

// const defaultMaterialTheme = createTheme({
//     //palette: {
//     //    primary: {
//     //        main: '#4caf50',
//     //    },
//     //    secondary: {
//     //        main: '#ff9100',
//     //    },
//     //},
//     components: {
//     // Name of the component
//         MuiTableCell: {
//             styleOverrides: {
//             // Name of the slot
//                 root: {
//                 // Some CSS
//                     //color:'red',
//                     textAlign:'center',
//                     //alignItems:'right',
//                     //justifyContent:'right'
//                 },
//             },
//         },
//     },

// });

export function CircularProgressWithLabel(props) {
    CircularProgressWithLabel.propTypes = {
        /**
         * The value of the progress indicator for the determinate variant.
         * Value between 0 and 100.
         * @default 0
         */
        value: PropTypes.number.isRequired,
    };
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress
                variant="determinate"
                {...props}
            />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography
                    variant="caption"
                    component="div"
                    color="text.secondary"
                >
                    {`${Math.round(props.value)}%`}
                </Typography>
            </Box>
        </Box>
    );
}

